export default __webpack_public_path__ + "static/media/house1.01916fe1.png";